module.exports = __webpack_public_path__ + "img/default_service_mobile.593548dc.svg";